import { Button } from 'common/Button'
import { ErrorCodes } from 'config/errorCodes'
import { PaymentOptions } from 'containers/PaymentModal/types'
import { PostType } from 'graphql/types'
import { useStore } from 'lib/store'
import { isValidChain } from 'lib/web3/chains'
import { useObserver } from 'mobx-react-lite'
import { Post } from 'models/Post'
import { Profile } from 'models/Profile'

const resolvePaymentOption = (post?: Post) => {
  if (!post) {
    return PaymentOptions.TIP_PROFILE
  }
  switch (true) {
    case post.type === PostType.EXCLUSIVE && !post.isVisible:
      return PaymentOptions.EXCLUSIVE_POST
    case post.type === PostType.SUBSCRIPTION && !post.isSubscribed:
      return PaymentOptions.SUBSCRIBE_PROFILE
    default:
      return PaymentOptions.TIP_POST
  }
}

interface Props {
  post?: Post
  profile?: Profile
  paymentType?: PaymentOptions
}

export const useHandlePayment = ({ post, profile, paymentType }: Props) => {
  const store = useStore()

  const _profile = post ? post.profile : profile

  return useObserver(() => {
    const handlePayment = async () => {
      if (store.ui.handleGatedAction()) return

      if (!_profile) {
        console.error('Cannot handle payment without a creator profile to pay')
        return
      }

      // --- guards
      switch (true) {
        // wallet is not connected
        case !store.injectedWallet.connectedWallet:
          console.log('---- No connected wallet detected -----')
          break
        // wallet has incorrect chainId selected
        case !isValidChain(store.wallets.connected?.chainId):
          console.log('---- wallet mapped to incorrect chain -----')
          store.wallets.connected?.switchChain(store.injectedWallet.selectedNetwork?.id)
          break
        // wallet has not been "linked"
        // case !store.injectedWallet.isLinked:
        //   console.log('---- wallet has not been "linked" -----')
        //   console.log('---- wallet has not been "linked" -----')
        //   console.log('---- wallet has not been "linked" -----')
        //   store.ui.openConnectModal('LINK_WALLET')
        //   break
        default:
          console.log('---- useHandlePayment -----')
          console.log('---- useHandlePayment -----')
          console.log('---- useHandlePayment -----')
          console.log({
            post,
            profile: _profile,
            paymentType: paymentType ? paymentType : resolvePaymentOption(post)
          })

          store.transaction.setTransaction({
            post,
            profile: _profile,
            paymentType: paymentType ? paymentType : resolvePaymentOption(post)
          })
          store.ui.togglePaymentModal()
          break
      }
    }

    return { handlePayment }
  })
}
